import React from 'react';

import DatetimeField from 'components/DatetimeField';

export default props => (
  <DatetimeField
    {...props}
    showTime={false}
  />
);
